interface SingShopIntegrationPluginConfig {
  pluginUrl: string;
  pluginVersion: string;
}

class SingShopIntegrationPlugin {
  constructor() {
    console.log('SingShopIntegrationPlugin initialized');
  }

}

document.addEventListener('DOMContentLoaded', () => {
  window.SingShopIntegrationPluginInstance = new SingShopIntegrationPlugin();
});

declare global {
  interface Window {
    SingShopIntegrationPluginInstance: SingShopIntegrationPlugin;
    SingShopIntegrationPluginConfig: SingShopIntegrationPluginConfig; // See my-new-plugin.php for setting this variable
  }
}

export {};
